'use client';

import { PageLayoutComponent } from './PageLayoutComponent';
import { cn } from '@/lib/utils';
import StudioLogo from '@/src/components/StudioLogo';
import Header from '@/components/Header';
import ShopifyHeader from '@/components/ShopifyHeader';
import ShopifyNavigation from '@/components/navigation/ShopifyNavigation';
import Link from 'next/link';

export const NotAuthenticatedLayout: PageLayoutComponent = ({
  children,
  isShopifyIframe = false,
}: {
  children: React.ReactNode;
  isShopifyIframe?: boolean;
}) => {
  return (
    <>
      {isShopifyIframe ? (
        <>
          <ShopifyNavigation />
          {/* <ShopifyHeader /> */}
          {children}
        </>
      ) : (
        <div className="grid h-full sm:max-h-screen sm:grid-cols-[240px_1fr]">
          <div className="grid sm:max-h-screen sm:grid-rows-[60px_1fr]">
            <div
              className={cn(
                'flex items-center px-4',
                'bg-white',
                'border-0 border-b-2 border-solid border-[var(--p-color-border)]'
              )}
            >
              <Link href="/">
                <StudioLogo />
              </Link>
            </div>
          </div>
          <div className="grid sm:max-h-screen sm:grid-rows-[60px_1fr]">
            <Header className={cn('bg-white', 'border-0 border-b-2 border-solid border-[var(--p-color-border)]')} />
            <div className="overflow-y-auto">{children}</div>
          </div>
        </div>
      )}
    </>
  );
};
